module.exports = __webpack_public_path__ + "img/02-illu-haruka0125.158065d1.png";